module.exports = __webpack_public_path__ + "static/img/bg_login.d5d95cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_login.png
// module id = BgUH
// module chunks = 1